import { render, staticRenderFns } from "./DistributorGoodsIndex.vue?vue&type=template&id=217d915b"
import script from "./DistributorGoodsIndex.vue?vue&type=script&lang=js"
export * from "./DistributorGoodsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports